var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wgt-devices"},[_c('SpImage',{attrs:{"src":"https://cdn-image.tjtjshengtu.com/icon/equipment.png"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }